<script>
	import { documentos, cuenta } from './../controlador/store.js';
	import { beforeUpdate } from 'svelte';
import RecetasController from '../controlador/recetasController.svelte';
	import ItemHistorial from './../componentes/itemHistorial.svelte';
    let control;    
    let filtro = '';
    let lista = [];
        beforeUpdate(()=>{
            lista = $documentos.filter((el)=>el._id.includes(`recetas:${$cuenta.user}`))
            .filter((el)=> {
                return (el.nombre.toLocaleLowerCase().includes(filtro.toLocaleLowerCase()) ||
                el.documento.toLocaleLowerCase().includes(filtro.toLocaleLowerCase()) ||
                el.mutual.toLocaleLowerCase().includes(filtro.toLocaleLowerCase()) ||
                el.afiliado.toLocaleLowerCase().includes(filtro.toLocaleLowerCase()))
            }).reverse();
        });
        
</script>
<RecetasController bind:this={control}/>
<div class="container scroll"><!-- este es el q puede scrolear en todos-->
    <h2>Historial</h2>
    <input type="text" placeholder="Filtrar Recetas" bind:value={filtro}>
	{#each lista as t}
        <ItemHistorial item={t} />
	{/each}
</div>

<style>
    h2{
		color: white;
		width: 100%;
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
    }
    input{
        width: 90%;
        max-width: 380px;
        margin-bottom: 10px;
        border: none;
        outline: none;
        border-radius: 10px;
        height: 30px;
        padding: 5px;
    }
	.scroll {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		overflow-y: scroll;
	}
	.boton{
		background: transparent;
		border: none;
		outline: none;
		cursor: pointer;
		color: white;
		margin: 10px;
		padding: 5px;
		text-decoration: none;
	}
</style>
    